import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { save } from './ExportButtons.js';
import { Button, Checkbox } from './ui.js';

/**
 * The recovery codes of the second factor, shown once after they are made (SP-D18): copy them or
 * save them as a file, confirm, go on. Only their hashes are kept on the server.
 */
export function RecoveryCodes({
  codes,
  doneLabel,
  onDone,
}: {
  codes: readonly string[];
  doneLabel: string;
  onDone: () => void;
}) {
  const { t } = useTranslation();
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = codes.join('\n');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      // No clipboard (an old browser, no permission): the codes stay on the screen to copy.
    }
  };
  return (
    <div className="recovery">
      <p className="bodyM">{t('mfa.codes.text')}</p>
      <ol className="codes" aria-label={t('mfa.codes.label')}>
        {codes.map((code) => (
          <li key={code}>
            <code>{code}</code>
          </li>
        ))}
      </ol>
      <div className="acts">
        <Button variant="secondary" size="sm" onClick={() => void copy()}>
          {copied ? t('mfa.codes.copied') : t('mfa.codes.copy')}
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={() =>
            save(
              new Blob([`${t('mfa.codes.fileHead')}\n\n${text}\n`], { type: 'text/plain' }),
              'recovery-codes.txt',
            )
          }
        >
          {t('mfa.codes.download')}
        </Button>
      </div>
      <Checkbox
        label={t('mfa.codes.saved')}
        checked={saved}
        onChange={(e) => setSaved(e.target.checked)}
      />
      <div className="acts">
        <Button disabled={!saved} onClick={onDone}>
          {doneLabel}
        </Button>
      </div>
    </div>
  );
}
